import { ca } from '@cian/analytics';

export function trackFirstInteractionForm() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: 'FocusInForm',
  });
}
